import moment from "moment";
import { useNavigate } from "react-router-dom";
import { Fragment } from "react/jsx-runtime";
import {
    Avatar,
    Box,
    Divider,
    IconButton,
    List,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
    Menu,
    Typography
} from "@mui/material";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import VisibilityIcon from '@mui/icons-material/Visibility'; // Ícone para "vista"
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'; // Ícone para "não vista"
import { Notifications } from "./NotificationType";
import { api } from "../services/api";
import { Dispatch, SetStateAction } from "react";

type NotificationProps = {
    anchorEl: any,
    setAnchorEl: any,
    notifications: Notifications[],
    setNotification: Dispatch<SetStateAction<Notifications[]>>
}

export default function NotificationsMenu({ anchorEl, setAnchorEl, notifications, setNotification }: NotificationProps) {
    const navigate = useNavigate();

    async function handleNotification(params: Notifications) {
        await handleToggleRead(params.id_notification, 0);
        navigate(params.notification_query);
        setAnchorEl(null);
    }

    async function handleToggleRead(id_notification: number, is_read: number) {
        const read = notifications.map(i => {
            if (i.id_notification === id_notification) return { ...i, is_read: Number(!Boolean(is_read)) }
            return i;
        });
        setNotification(read);
        await api.get(`/readnotification/${id_notification}/${Number(!Boolean(is_read))}`);
    }

    return (
        <Menu
            id="notification-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
            MenuListProps={{
                'aria-labelledby': 'notification-button',
            }}
            // Ajuste de posicionamento para o menu
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
        >
            {/* Cabeçalho do menu */}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    pl: 1,
                    pr: 1,
                    borderBottom: '1px solid #e0e0e0',
                }}
            >
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                    Notificações
                </Typography>
                <IconButton sx={{ color: 'success.main' }}>
                    <CheckCircleOutlineIcon />
                </IconButton>
            </Box>

            <List sx={{ py: 0 }}>
                {/* Notificação de aniversário */}
                {notifications.map(item => (
                    <>
                        <ListItem
                            alignItems="flex-start"
                            button
                            onClick={() => handleNotification(item)}
                            sx={{
                                bgcolor: item.is_read === 1 ? 'action.hover' : 'background.paper'
                            }}
                        >
                            <ListItemAvatar>
                                <Avatar sx={{ bgcolor: 'success.light', color: 'inherit.main', width: 42, height: 42 }}>
                                    <DocumentScannerIcon />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                                primary={
                                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                        {item.notification_text}
                                    </Typography>
                                }
                                secondary={
                                    <Fragment>
                                        <Typography
                                            sx={{ display: 'inline' }}
                                            component="span"
                                            variant="body2"
                                            color="text.secondary"
                                        >
                                            {moment(item.create_notification).format("DD/MM/YYYY HH:mm")}
                                        </Typography>
                                    </Fragment>
                                }
                            />
                            <ListItemSecondaryAction>
                                <IconButton
                                    edge="end"
                                    aria-label="toggle read status"
                                    onClick={() => handleToggleRead(item.id_notification, item.is_read)}
                                >
                                    {item.is_read === 1 ? <VisibilityIcon fontSize="small" color="primary" /> : <FiberManualRecordIcon fontSize="small" color="secondary" />}
                                </IconButton>
                            </ListItemSecondaryAction>
                        </ListItem>
                        <Divider />
                    </>
                ))}
            </List>
        </Menu>
    );
}